const STORAGE_KEY = 'app_error_log'
const MAX_ENTRIES = 500

const safeStringify = (value) => {
    try {
        return JSON.stringify(value)
    } catch (e) {
        return String(value)
    }
}

const loadLog = () => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY)
        if (!raw) return []
        const parsed = JSON.parse(raw)
        return Array.isArray(parsed) ? parsed : []
    } catch (e) {
        return []
    }
}

const saveLog = (entries) => {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(entries))
    } catch (e) {
        try {
            const trimmed = entries.slice(-Math.floor(MAX_ENTRIES / 2))
            localStorage.setItem(STORAGE_KEY, JSON.stringify(trimmed))
        } catch (_) {
            // ignore
        }
    }
}

export const logError = (type, message, extra = {}) => {
    try {
        const entries = loadLog()
        entries.push({
            ts: new Date().toISOString(),
            type,
            message: typeof message === 'string' ? message : safeStringify(message),
            url: typeof window !== 'undefined' ? window.location?.pathname : undefined,
            ...extra,
        })
        if (entries.length > MAX_ENTRIES) {
            entries.splice(0, entries.length - MAX_ENTRIES)
        }
        saveLog(entries)
    } catch (e) {
        // logger ne smije rušiti aplikaciju
    }
    try {
        // eslint-disable-next-line global-require
        const {notifyCriticalIfNeeded} = require('./logSender')
        notifyCriticalIfNeeded(type)
    } catch (_) {
        // ignore
    }
}

export const getErrorLogs = () => loadLog()

export const getUnsentErrorLogs = () => loadLog().filter((e) => !e.sent)

export const markErrorLogsSent = (timestamps) => {
    if (!Array.isArray(timestamps) || timestamps.length === 0) return
    try {
        const set = new Set(timestamps)
        const entries = loadLog()
        let changed = false
        for (const e of entries) {
            if (!e.sent && set.has(e.ts)) {
                e.sent = true
                changed = true
            }
        }
        if (changed) saveLog(entries)
    } catch (_) {
        // ignore
    }
}

export const clearErrorLogs = () => {
    try {
        localStorage.removeItem(STORAGE_KEY)
    } catch (e) {
        // ignore
    }
}

export const formatErrorLogs = () => {
    const entries = loadLog()
    if (entries.length === 0) return '(prazno)'
    return entries
        .map((e) => {
            const { ts, type, message, ...rest } = e
            const restStr = Object.keys(rest).length ? ' ' + safeStringify(rest) : ''
            return `[${ts}] ${type}: ${message}${restStr}`
        })
        .join('\n')
}

let installed = false
export const installGlobalErrorHandlers = () => {
    if (installed || typeof window === 'undefined') return
    installed = true

    window.addEventListener('error', (event) => {
        logError('JS_ERR', event?.message || 'window error', {
            source: event?.filename,
            line: event?.lineno,
            col: event?.colno,
            stack: event?.error?.stack,
        })
    })

    window.addEventListener('unhandledrejection', (event) => {
        const reason = event?.reason
        const message = reason?.message || (typeof reason === 'string' ? reason : safeStringify(reason))
        logError('PROMISE_ERR', message, {
            stack: reason?.stack,
        })
    })
}
